import { Route, Routes } from 'react-router';
import './App.css';
import Navbar from './components/Navbar';
import AddTask from './pages/AddTask';
import Home from './pages/Home';

function App() {

  return (
    <div className="text-[#111827]">
        <Navbar/>
<Routes>

  <Route path='/' element={<Home/>} />
  <Route path='/add-task' key={1} element={<AddTask/>} />
  <Route path='/edit-task/:id' key={2} element={<AddTask/>} />
</Routes>

  
    </div>
  );
}

export default App;
